import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../shared.functions';
import { GenericResponse, SearchProveedorRequest, SaveProveedorDto, Proveedor, ReporteProductividadDto } from "../model/index";

@Injectable({
  providedIn: 'root'
})
export class ProveedorService extends CrudService<Proveedor, number, SaveProveedorDto, SearchProveedorRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'proveedor', sharedFunctions);
  }

  getReporteProductividad(proveedorId: number): Observable<GenericResponse<ReporteProductividadDto>> {
    return this._http.get<GenericResponse<ReporteProductividadDto>>(this._serviceUrl +'/reporte-productividad/'+proveedorId, this.httpOptions);
  }
}